import { apiClient } from './apiClient';
import type { InvitationDetails, AgentRegistrationRequest, AuthResponse } from '../types/auth';

export const invitationService = {
  /**
   * Get invitation details from token
   */
  async getInvitationDetails(token: string): Promise<InvitationDetails> {
    return apiClient.get<InvitationDetails>(`/agent/invitation/${token}`);
  },

  /**
   * Register agent with invitation token
   */
  async registerAgent(request: AgentRegistrationRequest): Promise<AuthResponse> {
    return apiClient.post<AuthResponse>('/auth/register/agent', request);
  },
};